import { createMainMenuNodeFromEntry } from 'experiments/deeplinks-flow-feature/treatment/features/menu/utils/create-main-menu-node-from-entry';
import { EntryTypeEnum } from 'generated/graphql-gateway';
import { ILocalizedMenuEntry, IMainMenuNode, PosServiceMode } from 'state/unified-menu/types';
import { normalizeType } from 'state/unified-menu/utils';

const PRODUCT_TYPES = new Set([
  normalizeType(EntryTypeEnum.ITEM),
  normalizeType(EntryTypeEnum.COMBO),
  normalizeType(EntryTypeEnum.PICKER),
]);

function isProductEntry(entry: ILocalizedMenuEntry): boolean {
  return PRODUCT_TYPES.has(normalizeType(entry.type));
}

/**
 * Pins an unavailable item/combo/picker as the first Full Menu card, followed by
 * the store’s available menu categories (“other available options”).
 */
export function buildUnavailableProductFullMenuRecoveryData({
  unavailableItemId,
  storeSections,
  resolveEntry,
  posServiceMode = 'pickup',
}: {
  unavailableItemId: string;
  storeSections: readonly IMainMenuNode[];
  resolveEntry: (id: string) => ILocalizedMenuEntry | undefined;
  posServiceMode?: PosServiceMode;
}): { data: IMainMenuNode[]; deeplinkUnavailableItemId: string } | null {
  if (!unavailableItemId || storeSections.length === 0) {
    return null;
  }

  const entry = resolveEntry(unavailableItemId);
  if (!entry || !isProductEntry(entry)) {
    return null;
  }

  const productNode = createMainMenuNodeFromEntry(entry, posServiceMode);
  const others = storeSections.filter(section => section.id !== productNode.id);
  if (others.length === 0) {
    return null;
  }

  return {
    data: [productNode, ...others],
    deeplinkUnavailableItemId: unavailableItemId,
  };
}
